import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../auth/api';
import { alertSuccess, alertError } from '../../components/Alert';

// Fetch pageHeader data
export const fetchPageHeaderData = createAsyncThunk(
  'pageHeader/fetchPageHeaderData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/panel/pageHeader');
      return response.data; // Adjust based on your API response structure\
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update pageHeader data
export const updatePageHeaderData = createAsyncThunk(
  'pageHeader/updatePageHeaderData',
  async (pageHeaderData, { rejectWithValue }) => {
    try {
      const response = await api.patch('/panel/pageHeader', pageHeaderData);
      alertSuccess(response.data.success);
      return response.data; // Adjust based on your API response structure
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Add new pageHeader data
export const addPageHeaderData = createAsyncThunk(
  'pageHeader/addPageHeaderData',
  async (newPageHeaderData, { rejectWithValue }) => {
    try {
      const response = await api.post('/panel/pageHeader', newPageHeaderData);
      alertSuccess(response.data.success);
      return response.data; // Adjust based on your API response structure
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

const pageHeaderSlice = createSlice({
  name: 'pageHeader',
  initialState: {
    pageHeaderData: null, // Stores the fetched pageHeader data
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null, // Stores error messages
  },
  reducers: {
    clearPageHeaderData(state) {
      state.pageHeaderData = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchPageHeaderData
      .addCase(fetchPageHeaderData.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPageHeaderData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.pageHeaderData = action.payload;
      })
      .addCase(fetchPageHeaderData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Handle updatePageHeaderData
      .addCase(updatePageHeaderData.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updatePageHeaderData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.pageHeaderData = { ...state.pageHeaderData, ...action.payload }; // Update pageHeader data
      })
      .addCase(updatePageHeaderData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Handle addPageHeaderData
      .addCase(addPageHeaderData.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(addPageHeaderData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.pageHeaderData = [...(state.pageHeaderData || []), action.payload]; // Add new pageHeader data
      })
      .addCase(addPageHeaderData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { clearPageHeaderData } = pageHeaderSlice.actions;

export default pageHeaderSlice.reducer;
